import axios from "axios";
import { useEffect, useState } from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import { useNavigate } from "react-router";
import Actions from "../../../components/Common/Actions";
import CommonFilterModal from "../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../components/Common/TabBar";
import ListPageLayout from "../../../components/Layout";
import Deletepopup from "../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";
import { statuses } from "../../../Pages/Masters/Utils/MasterConst";
import { careernavBarData, PositionBreadcrumbs } from "../const";

const Position = () => {
  const navigate = useNavigate();

  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);
  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }))
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    Department: [],
    Designation: [],
    Status: [],
  });

  const [tempSelectedValues, setTempSelectedValues] = useState({
    Department: [],
    Designation: [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("Department");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}career-add-position/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "career-add-position",
    fetchData,
    setShowDelete
  );

  const handleEdit = (id) => {
    navigate(`/careerpositionEdit/${id}`);
  };

  const handleActive = (id, status) => {
    setLoader(true)
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}career-add-position/update/${id}`,
        {
          active: !status,
        }
      )
      .then((result) => {
        fetchData();
      });
  };

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search, selectedValues]);

  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
      fixed: "left",
      render: (text, record, index) => Number(pagination.skip) + (index + 1),
      width: 80,
    },
    {
      title: "Department / Function Name",
      dataIndex: "functionName1",
      key: "functionName1",
      fixed: "left",
      width: 290,
    },
    {
      title: "Position / Designation",
      dataIndex: "functionName2",
      key: "functionName2",
      width: 290,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isEdit={true}
          recordActiveStatus={record.active}
          isActive={true}
          isDelete={true}
          onClickActive={() => handleActive(record._id, record.active)}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() => handleEdit(record._id)}
        />
      ),
    },
  ];

  // Prepare the dataSource for the table
  const dataSource = records
    ?.filter((el) => el.show === undefined || el.show === true)
    .map((el) => ({
      key: el._id,
      _id: el._id,
      functionName1: el.functionName1,
      functionName2: el.functionName2,
      active: el.active,
    }));

  const filters = {
    Department: ["Engineering", "Sales", "Content", "Back Office Operations"],
    Designation: ["Web Developer", "Content Market", "Web Designer"],
    Status: statuses,
  };

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<PositionBreadcrumbs />}
      addButton={
        <div
          id="addnewpost"
          onClick={() => navigate("/careerpositionForm")}
          className="addnewhealth"
          style={{ width: "240px" }}
        >
          <div>
            <AiFillPlusCircle color="#4E91C2" size={25} />
          </div>
          <div>
            <button className="text-nowrap">Add Position/Designation</button>
          </div>
        </div>
      }
      titles={<NavBarTitles titles={careernavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
        }}
        onReset={() => {
          setTempSelectedValues({
            Department: [],
            Designation: [],
            Status: [],
          });
          setSelectedValues({
            Department: [],
            Designation: [],
            Status: [],
          });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default Position;
